import { ServiceGroup, VehicleMaintenanceScheduleServiceDue, VehicleTemplateDetail } from '@quorum/models/xs-resource';

type ServiceDueWithGroupId = Pick<VehicleMaintenanceScheduleServiceDue, 'serviceGroupId'>;

/**
 * Service groups are only loaded for the employee's rooftop and global (-1) groups, so a vehicle's
 * schedule can reference a group the menu never received. Such a service can't be rendered or
 * priced, and building it would throw and take the whole menu stream down, so it is dropped.
 */
export function servicesDueWithMenuData<T extends ServiceDueWithGroupId>(
  servicesDue: readonly T[],
  serviceGroups: Readonly<Record<string, ServiceGroup>>,
  templateDetail: readonly VehicleTemplateDetail[]
): T[] {
  const hasMenuData = (serviceDue: T): boolean =>
    !!serviceGroups[serviceDue.serviceGroupId] &&
    templateDetail.some((detail) => detail.serviceGroupId === serviceDue.serviceGroupId);

  const missing = servicesDue.filter((serviceDue) => !hasMenuData(serviceDue));
  if (missing.length > 0) {
    console.warn(
      'Maintenance menu: skipping services due with no loaded service group or template detail',
      missing.map((serviceDue) => serviceDue.serviceGroupId)
    );
  }

  return servicesDue.filter(hasMenuData);
}
